import Loadable from "@loadable/component"
export default Loadable(() => import("./ProductDetailBuilder"))
